// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__1bkWf","logoText":"Logo_logoText__fMQfs"};